import React, { useState, useMemo } from "react";
import { PRODUCTS, PRODUCT_CATEGORIES } from "../../data/products";
import ProductCard from "./ProductCard";
import { useLanguage } from "../../i18n/LanguageContext";
import { ShoppingBag } from "lucide-react";

export default function Tienda() {
  const { t } = useLanguage();
  const [activeCat, setActiveCat] = useState("all");

  const filtered = useMemo(
    () => (activeCat === "all" ? PRODUCTS : PRODUCTS.filter((p) => p.category === activeCat)),
    [activeCat],
  );

  return (
    <section
      id="tienda"
      data-testid="tienda-section"
      className="relative py-24 md:py-32 border-t border-[#E5E0D8] bg-[#F2EDE3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12 items-end">
          <div className="lg:col-span-8">
            <div className="eyebrow mb-4 flex items-center gap-3">
              <ShoppingBag className="h-3.5 w-3.5" />
              {t.tienda.eyebrow}
            </div>
            <h2
              data-testid="tienda-title"
              className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-[#1A1A1A]"
            >
              {t.tienda.title}
            </h2>
            <p className="mt-5 text-[#5C5C5C] leading-relaxed max-w-2xl">
              {t.tienda.subtitle}
            </p>
          </div>
        </div>

        {/* Category tabs */}
        <div
          className="flex flex-wrap gap-2 mb-10 pb-6 border-b border-[#E5E0D8]"
          data-testid="tienda-tabs"
        >
          {PRODUCT_CATEGORIES.map((cat) => {
            const isActive = cat.id === activeCat;
            return (
              <button
                key={cat.id}
                data-testid={`tienda-tab-${cat.id}`}
                onClick={() => setActiveCat(cat.id)}
                className={`px-4 md:px-5 py-2.5 text-[0.7rem] md:text-xs tracking-[0.2em] uppercase font-semibold transition-colors ${
                  isActive
                    ? "bg-[#1A1A1A] text-white"
                    : "bg-white text-[#1A1A1A] hover:bg-[#1A1A1A]/5 border border-[#E5E0D8]"
                }`}
              >
                {t.tienda.categories[cat.id]}
              </button>
            );
          })}
        </div>

        {/* Products grid */}
        <div
          data-testid="tienda-grid"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8"
        >
          {filtered.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
